import { Box, InputBase, Typography } from "@mui/material"
import { useTranslation } from "react-i18next";


export const Field = ({name, isDisabled = false, title, handleInputChange, required = false, small = false, translation}) => {

    const { t } = useTranslation('global');

    return (
        <Box minWidth={small ? 'calc(33% - 5px)' : 'calc(50% - 8px)'}>
            <Typography variant='overline' color='secondary'>{t(`${translation}.${title}`)}</Typography>
            <InputBase 
                fullWidth
                name={title}
                size="small"
                variant="standard"
                value={name || ''}
                disabled={isDisabled}
                onChange={handleInputChange}
                required={required}
                type={title === 'email' ? 'email' : 'text'}
            />
        </Box>
    )
}
